<script>
  import clsx from "clsx";

  let className = null;
  export { className as class };
  export let badge = false;
</script>

<span class={clsx(className, "flex h-3 w-3")}>
  {#if badge == "warning"}
    <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-75" />
    <span class="relative inline-flex h-3 w-3 rounded-full bg-im-signal" />
  {:else}
    <span class={clsx("relative inline-flex h-3 w-3 rounded-full ", badge == "success" ? "bg-green-500" : badge)} />
  {/if}
</span>
